import { apiDelete, apiGet, apiPost, apiPut } from "./api-service";

const path = "incident";

export interface IncidentQuestionAnswer {
  id?: string;
  question?: string;
  answer: string;
  required?: boolean;
}

export interface IncidentDocument {
  id?: string;
  s3_key: string;
  name: string;
}

export interface IncidentCreateUpdateRequest {
  site_id: string;
  employee_id: string;
  type_id: string;
  description: string;
  other_parties: string;
  other_employee_ids?: string[];
  gps_coordinates: string;
  question_answers?: IncidentQuestionAnswer[];
  documents?: IncidentDocument[];
  location: string;
  incident_description: string;
  reporting_employee_id: string;
}

export async function createIncident(data: IncidentCreateUpdateRequest) {
  const response = await apiPost("core", path, data);
  return response;
}

export async function updateIncident(id: string, data: IncidentCreateUpdateRequest) {
  const response = await apiPut("core", `${path}/${id}`, data);
  return response;
}

export async function getIncident(id: string) {
  const response = await apiGet("core", `${path}/${id}`);
  return response;
}

export async function deleteIncident(id: string) {
  const response = await apiDelete("core", `${path}/${id}`, {});
  return response;
}

export interface IncidentQueryParams {
  dateFrom?: string;
  dateTo?: string;
  employeeId?: string;
  siteId?: string;
  typeId?: string;
  page?: number;
  limit?: number;
  clientId?: string;
}

export interface IncidentResponse {
  message: string;
  errors: any[];
  content: {
    rows: IncidentItem[];
    total: string;
  };
}

export interface IncidentItem {
  id: string;
  client_id: string;
  site_id: string;
  employee_id: string;
  type_id: string;
  description: string;
  other_parties: string;
  gps_coordinates: string;
  created_at: string;
  updated_at: string | null;
  deleted_at: string | null;
  site_name: string;
  employee_name: string;
  type_name: string;
}

export async function getIncidents(params: IncidentQueryParams) {
  const queryParams: Record<string, string> = {};

  if (params.dateFrom) queryParams.dateFrom = params.dateFrom;
  if (params.dateTo) queryParams.dateTo = params.dateTo;
  if (params.employeeId) queryParams.employeeId = params.employeeId;
  if (params.siteId) queryParams.siteId = params.siteId;
  if (params.typeId) queryParams.typeId = params.typeId;
  if (params.page) queryParams.page = params.page.toString();
  if (params.limit) queryParams.limit = params.limit.toString();

  const response = await apiGet("core", `${path}`, {
    queryParams,
    headers: {
      "X-Client-ID": params.clientId || "",
    },
  });

  return response as IncidentResponse;
}
